import Vue from 'vue'
import store from './store/index'
import App from './App.vue'
import moment from 'moment'
import './registerServiceWorker'
import '@babel/polyfill'
import packageInfo from '../package.json'
import * as Sentry from '@sentry/vue'
import VueGtag from 'vue-gtag'

// GA4 설정
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
  appName: 'tabling-w-screen',
  pageTrackerScreenviewEnabled: true
})

Sentry.init({
  Vue,
  dsn: 'https://636d98ad31343f6d35599b3e16ea0e40@sentry.tabling.co.kr/7',
  integrations: [
    new Sentry.Replay()
  ],
  environment: process.env.VUE_APP_ENV,
  tracesSampleRate: 0.3,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.3,
  release: `${packageInfo.name}@${packageInfo.version}`
})

Vue.prototype.$moment = moment
Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
